/**
 * The ⓘ beside the comparable value opens the pricing-policy lightbox.
 *
 * Plain HTMLElement rather than the theme's Component base, matching the other
 * noonbrook blocks in this theme. The dialog is a native <dialog>, so Escape and the
 * backdrop come for free and focus is contained without any of it being written here.
 */
class CompPrice extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;

    this.controller = new AbortController();
    const { signal } = this.controller;

    for (const trigger of this.querySelectorAll('[data-comp-open]')) {
      trigger.addEventListener('click', () => this.dialog?.showModal(), { signal });
    }
    for (const closer of this.querySelectorAll('[data-comp-close]')) {
      closer.addEventListener('click', () => this.dialog?.close(), { signal });
    }

    // Clicking the backdrop closes it. The click lands on the dialog itself rather
    // than on the panel inside, so comparing targets is enough to tell them apart.
    this.dialog.addEventListener(
      'click',
      (event) => {
        if (event.target === this.dialog) this.dialog.close();
      },
      { signal }
    );
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('comp-price')) {
  customElements.define('comp-price', CompPrice);
}
